import { UserBookmarkCountBy } from "models/enumerations/sorting/user-bookmarks/user-bookmark-count-by";
import { useHistory, useLocation } from "react-router";
import { RouteUtils } from "utilities/route-utils";

const useActiveBookmarkGroups = (group: UserBookmarkCountBy) => {
    const { pathname, search } = useLocation();
    const { replace } = useHistory();

    const { [group]: rawActiveGroups } = RouteUtils.queryStringToObject<{
        [key: string]: string;
    }>(search);

    const activeGroups = rawActiveGroups ? JSON.parse(rawActiveGroups) : [];

    const onShowGroup = (group: string | number) => {
        onGroupChange([...activeGroups.filter((x) => x !== group), group]);
    };

    const onHideGroup = (group: string | number) => {
        onGroupChange([...activeGroups].filter((x) => x !== group));
    };

    const onGroupChange = (newVal: string[]) => {
        const { [group]: oldActiveGroups, ...otherParams } =
            RouteUtils.queryStringToObject<{
                [key: string]: any;
            }>(search);
        replace(
            RouteUtils.appendQueryParams(pathname, {
                ...otherParams,
                [group]: JSON.stringify(newVal),
            })
        );
    };

    const isOpen = (code: string | number) =>
        activeGroups.some((ag) => ag === code);

    return { activeGroups, onGroupChange, onShowGroup, onHideGroup, isOpen };
};

export default useActiveBookmarkGroups;
